var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bridge-bg"}),_c('BridgeHero'),_c('Bridge')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }